export default async function wait(timeout: number) {
  return new Promise<void>(resolve => {
    setTimeout(() => resolve(), timeout)
  })
}
